import React from "react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";
import ManualPaymentForm from "~/pages/payments/components/ManualPaymentForm";

const ManualPaymentsPage = () => {
  return (
    <div className="container mx-auto max-w-3xl py-6">
      <Card>
        <CardHeader>
          <CardTitle>Registro de Pago Manual</CardTitle>
          <CardDescription>
            Ingrese los detalles del pago manual para registrarlo en el sistema
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ManualPaymentForm />
        </CardContent>
      </Card>
    </div>
  );
};

export default ManualPaymentsPage;
